import React, { useState, useEffect, useRef } from "react";

const MediaShowcase = ({ mediaItems, showVideo = true }) => {
  const filteredMedia = showVideo
    ? mediaItems
    : mediaItems.filter((item) => item.type === "image");

  const [currentIndex, setCurrentIndex] = useState(0);
  const autoFlipRef = useRef(null);

  const prevMedia = () => {
    setCurrentIndex((prev) => (prev === 0 ? filteredMedia.length - 1 : prev - 1));
  };

  const nextMedia = () => {
    setCurrentIndex((prev) =>
      prev === filteredMedia.length - 1 ? 0 : prev + 1
    );
  };

  // Auto-flip every 5 seconds
  useEffect(() => {
    autoFlipRef.current = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === filteredMedia.length - 1 ? 0 : prev + 1
      );
    }, 4000);

    return () => clearInterval(autoFlipRef.current);
  }, [filteredMedia.length]);

  const pauseAutoFlip = () => clearInterval(autoFlipRef.current);
  const resumeAutoFlip = () => {
    autoFlipRef.current = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === filteredMedia.length - 1 ? 0 : prev + 1
      );
    }, 5000);
  };

  return (
    <div className="w-full max-w-3xl mx-auto text-center">
      {/* Media Container */}
      <div
        className="w-full max-w-2xl h-64 md:h-96 mx-auto flex items-center justify-center bg-gray-100 rounded-lg shadow-lg overflow-hidden relative"
        onMouseEnter={pauseAutoFlip}
        onMouseLeave={resumeAutoFlip}
      >
        {/* Media Content */}
        {filteredMedia[currentIndex].type === "video" ? (
          <video className="w-full h-full object-cover" controls autoPlay muted loop>
            <source src={filteredMedia[currentIndex].src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : filteredMedia[currentIndex].type === "youtube" ? (
          <iframe
            key={currentIndex}
            className="w-full h-full object-contain"
            src={`${filteredMedia[currentIndex].src}?autoplay=1&mute=1&rel=0&modestbranding=1&showinfo=0&iv_load_policy=3&playlist=${filteredMedia[currentIndex].src.split("/").pop()}`}
            title="YouTube Video"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        ) : (
          <div className="w-[90%] h-[90%] flex items-center justify-center">
            <img
              src={filteredMedia[currentIndex].src}
              alt={`Media ${currentIndex + 1}`}
              className="w-auto h-auto max-w-full max-h-full"
            />
          </div>
        )}

        {/* Overlay Navigation Arrows */}
        {filteredMedia.length > 1 && (
          <>
            <button
              onClick={prevMedia}
              className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-20 hover:bg-opacity-50 text-white p-2 md:p-3 rounded-full transition-all z-10"
            >
              &#10094;
            </button>
            <button
              onClick={nextMedia}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-20 hover:bg-opacity-50 text-white p-2 md:p-3 rounded-full transition-all z-10"
            >
              &#10095;
            </button>
          </>
        )}

        {/* Index Indicator */}
        <div className="absolute bottom-2 right-2 bg-black bg-opacity-60 text-white text-sm px-3 py-1 rounded-full z-10">
          {currentIndex + 1} of {filteredMedia.length}
        </div>
      </div>
    </div>
  );
};

export default MediaShowcase;
